import VueRouter from 'vue-router'
import Vue from 'vue'
import Vuex from 'vuex'

import { store } from '../store'

/*import Home from './components/Home'
import Profile from './components/Profile'
import Auth from './components/Auth'
import Protected from './components/Protected'

const routes = [
  { path: '/', component: Home },
  { path: '/auth', component: Auth },
  { path: '/protected', component: Protected, meta: { requiresAuth: true} },
  { path: '/profile', component: Profile, meta: { requiresAuth: true} }
]

const router = new VueRouter({
  routes
})*/

// Containers
const MainContainer = () =>
    import ('@/containers/MainContainer')

// Views
const Home = () =>
    import ('@/components/Home')

//const DefaultContainer = () => import('@/containers/DefaultContainer')
//const Dashboard = () => import('@/views/Dashboard')

const Login = () =>
    import ('@/components/Login')
const SetPassword = () =>
    import ('@/components/SetPassword')
const Registrati = () =>
    import ('@/components/Registrati')
const PasswordDimenticata = () =>
    import ('@/components/PasswordDimenticata')
const HomeImpianto = () =>
    import ('@/components/HomeImpianto')
const Centrali = () =>
    import ('@/components/Centrali')
const Emergenza = () =>
    import ('@/components/Emergenza')
const Illuminazione = () =>
    import ('@/components/Illuminazione')
const Sensori = () =>
    import ('@/components/Sensori')
const Aggregazioni = () =>
    import ('@/components/Aggregazioni')
const QrLamps = () =>
    import ('@/components/QrLamps')
const ReportImpianto = () =>
    import ('@/components/ReportImpianto')
const Scenari = () =>
    import ('@/components/Scenari')
const ScenariCentrale = () =>
    import ('@/components/ScenariCentrale')
const Zone = () =>
    import ('@/components/Zone')
const MonitoringZone = () =>
    import ('@/components/MonitoringZone/MonitoringZone')    
const ZoneDetail = () =>
    import ('@/components/ZoneDetail')
const GestioneZone = () =>
    import ('@/components/GestioneZone')
    //const Ambienti = () =>
    //    import ('@/components/Ambienti')
    //const Planimetrie = () =>
    //    import ('@/components/Planimetrie')
const AmbientiPlanimetrie = () =>
    import ('@/components/AmbientiPlanimetrie')
const UtentiImpianto = () =>
    import ('@/components/UtentiImpianto')
const GeneraliImpianto = () =>
    import ('@/components/GeneraliImpianto')
const AllPlants = () =>
    import ('@/components/AllPlants')
const UserProfile = () =>
    import ('@/components/UserProfile')
const Supporto = () =>
    import ('@/components/Supporto')
const TestResponsive = () =>
    import ('@/components/TestResponsive')
const NTOHome = () =>
    import ('@/components/NTOHome')
const NTOUsers = () =>
    import ('@/components/NTOUsers')
const NTOPendingUsers = () =>
    import ('@/components/NTOPendingUsers')
const NTOProCodes = () =>
    import ('@/components/NTOProCodes')
const NTOSummary = () =>
    import ('@/components/NTOSummary')  
const NTOAldi = () =>
    import ('@/components/NTOAldi')
const NTOPlantsMap = () =>
    import ('@/components/NTOPlantsMap')    
const BAHome = () =>
    import ('@/components/BAHome')    
const BAPlantsMap = () =>
    import ('@/components/BAPlantsMap')        
const ProductPage = () =>
    import ('@/components/ProductPage')
const DynamicLinkRedirect = () =>
    import ('@/components/DynamicLinkRedirect')
const QrFamily = () =>
    import ('@/components/QrFamilyRedirect')
const CreateBlePdfReport = () =>
    import ('@/components/CreateBlePdfReport')    
const LoginNew = () =>
    import ('@/components/LoginNew')
const RemotePanel = () =>
    import ('@/components/RemotePanel')
const BomImpianto = () =>
    import ('@/components/BomImpianto')
const BomImpiantoBle = () =>
    import ('@/components/BomImpiantoBle')

Vue.use(VueRouter)
Vue.use(Vuex)

const router = new VueRouter({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
})

function configRoutes() {
    return [{
            path: '/',
            redirect: '/home',
            name: 'Root',
            component: MainContainer,
            meta: { requiresAuth: true },
            children: [{
                    path: 'home',
                    name: 'Home',
                    component: Home,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plant/:pid',
                    name: 'HomeImpianto',
                    component: HomeImpianto,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'allplants/:userId',
                    name: 'AllPlants',
                    component: AllPlants,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'ntohome',
                    name: 'NTOHome',
                    component: NTOHome,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'ntousers',
                    name: 'NTOUsers',
                    component: NTOUsers,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'ntopendingusers',
                    name: 'NTOPendingUsers',
                    component: NTOPendingUsers,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'ntoprocodes',
                    name: 'NTOProCodes',
                    component: NTOProCodes,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'ntosummary',
                    name: 'NTOSummary',
                    component: NTOSummary,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'ntoplantsmap',
                    name: 'NTOPlantsMap',
                    component: NTOPlantsMap,
                    props: true,
                    meta: { requiresAuth: true }
                },

                {
                    path: 'ntoaldi',
                    name: 'NTOAldi',
                    component: NTOAldi,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'bahome',
                    name: 'BAHome',
                    component: BAHome,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'baplantsmap',
                    name: 'BAPlantsMap',
                    component: BAPlantsMap,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantreport/:plantId/:devicesType?',
                    name: 'ReportImpianto',
                    component: ReportImpianto,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'scenari/:plantId',
                    name: 'Scenari',
                    component: Scenari,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'scenaricentrale/:plantId',
                    name: 'ScenariCentrale',
                    component: ScenariCentrale,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'monitoringzone/:plantId',
                    name: 'MonitoringZone',
                    component: MonitoringZone,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'zone/zoneDetail/:plantId/:zoneId',
                    name: 'ZoneDetail',
                    component: ZoneDetail,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'zone/gestione/:plantId',
                    name: 'GestioneZone',
                    component: GestioneZone,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'zone/:plantId/:devicesType?',
                    name: 'Zone',
                    component: Zone,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantcentralunits/collection/:plantId',
                    name: 'Aggregazioni',
                    component: Aggregazioni,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantcentralunits/qrlamps/:plantId',
                    name: 'QrLamps',
                    component: QrLamps,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantcentralunits/:plantId/:devicesType?',
                    name: 'Centrali',
                    component: Centrali,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'remotepanel/:plantId',
                    name: 'RemotePanel',
                    component: RemotePanel,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantlocations/:plantId',
                    name: 'Ambienti',
                    component: AmbientiPlanimetrie,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantmaps/:plantId',
                    name: 'Planimetrie',
                    component: AmbientiPlanimetrie,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'userprofile/:userId/:event',
                    name: 'UserProfile',
                    component: UserProfile,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'supporto',
                    name: 'Supporto',
                    component: Supporto,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantusers/:plantId',
                    name: 'UtentiImpianto',
                    component: UtentiImpianto,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'plantgeneral/:plantId',
                    name: 'GeneraliImpianto',
                    component: GeneraliImpianto,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    // path: 'plantbom/:plantId/:devicesType',
                    path: 'plantbom/:plantId',
                    name: 'BomImpianto',
                    component: BomImpianto,
                    props: true,
                    meta: { requiresAuth: true }
                },
                {
                    // path: 'plantbomble/:plantId/:devicesType',
                    path: 'plantbomble/:plantId',
                    name: 'BomImpiantoBle',
                    component: BomImpiantoBle,
                    props: true,
                    meta: { requiresAuth: true }
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/setpassword',
            name: 'SetPassword',
            component: SetPassword,
            props: true
        },
        {
            path: '/registrati',
            name: 'Registrati',
            component: Registrati,
            props: true
        },
        {
            path: '/passworddimenticata',
            name: 'PasswordDimenticata',
            component: PasswordDimenticata,
            props: true
        },
        {
            path: '/responsive',
            name: 'Responsive',
            component: TestResponsive
        },
        {
            path: '/products/:productId',
            name: 'ProductPage',
            component: ProductPage
        },
        {
            path: '/qr/:pid',
            name: 'DynamicLinkRedirect',
            component: DynamicLinkRedirect,
            props: true
        },
        {
            path: '/qrf/:fid',
            name: 'QrFamily',
            component: QrFamily,
            props: true
        },
        {
            path: '/blereport/:plantId/:report',
            name: 'CreateBlePdfReport',
            component: CreateBlePdfReport,
            props: true
        },
        {
            path: '/loginnew',
            name: 'LoginNew',
            component: LoginNew,
            props: true
        },
    ]
}

router.beforeResolve((to, from, next) => {
    console.log("router to=", to, "from=", from);
    if (to.query.invite != null && to.query.inviteType != null) {
        console.log("salvo parametri invito ");
        store.state.invite = to.query.invite;
        store.state.inviteType = to.query.inviteType;
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
            let user
                //console.log("current user:");
            console.log("current user:", data);
            if (data && data.signInUserSession) {
                user = data;
                if (store.getters.user == null) {
                    store.commit('setLoggedUser', data)
                }
            }
            next()
        }).catch((e) => {
            console.log("errore verifica user");
            console.log(e);

            next({
                path: '/login'
            });
        });
    }
    next()
})

export default router